import { IElementsById } from "core-integration/src/store/elements/types";
import { ITransferState } from "core-integration/src/store/my-team/types";
import { getFreeTransfers } from "core-integration/src/store/squad/reducers";
import { ITransfersData } from "core-integration/src/store/squad/types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  leftAlignedCell,
  tableCell,
  tableStyles,
  tHead,
  totalsCell,
} from "../../../styles/sharedTableStyles.css";
import {
  containerStyles,
  costCell,
  costTableWrapper,
  tableTitle,
} from "./confirmTransfersSheet.css";

interface CostBreakdownTableProps {
  elementsById: IElementsById;
  transfers: ITransfersData[];
  transferState: ITransferState;
  transferCosts: number;
}

const CostBreakdownTable = ({
  elementsById,
  transfers,
  transferState,
  transferCosts,
}: CostBreakdownTableProps) => {
  const { t } = useTranslation("transfers");
  const freeTransfers = useSelector(getFreeTransfers);

  return (
    <div className={containerStyles}>
      <h2 className={tableTitle}>
        {t("confirmTransfers.costBreakdown.title", "Cost breakdown")}
      </h2>
      <div className={costTableWrapper}>
        <table className={tableStyles}>
          <thead className={tHead}>
            <tr>
              <th className={leftAlignedCell} scope="col">
                {t("confirmTransfers.costBreakdown.out", "Out")}
              </th>
              <th className={leftAlignedCell} scope="col">
                {t("confirmTransfers.costBreakdown.in", "In")}
              </th>
              <th className={costCell} scope="col">
                {t("common:cost", "Cost")}
              </th>
            </tr>
          </thead>
          <tbody>
            {transfers.map((transfer, index) => (
              <tr key={transfer.element_out}>
                <td className={tableCell}>
                  {transfer.element_out
                    ? elementsById[transfer.element_out].web_name
                    : "-"}
                </td>
                <td className={tableCell}>
                  {transfer.element_in
                    ? elementsById[transfer.element_in].web_name
                    : "-"}
                </td>
                <td className={tableCell}>
                  {transferCosts && index >= freeTransfers
                    ? transferState.cost
                    : 0}{" "}
                  {t("common:pointsAbbreviated", "pts")}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td className={totalsCell}>&nbsp;</td>
              <th className={totalsCell} align={"left"} scope="row">
                {t("common:totalCost", "Total cost")}
              </th>
              <td className={totalsCell}>
                {transferCosts} {t("common:pointsAbbreviated", "pts")}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default CostBreakdownTable;
